//
//
//
//

import Content from "~/components/Content"

export default {
	name: "method-index",
	props: {
		Content,
	},
	async asyncData({ store, route, $md }) {
		await store.dispatch("content/fetchContentByKeys", {
			path: route.path,
			keys: ["method"],
		})
		const content = store.getters["content/getContent"](route.path);
		if (content) {
			return {
				page: $md.render(content)
			}
		}
	},
	head() {
		return {
			title: `${this.$t(`method`)} – VoteLog`,
		}
	},
	nuxtI18n: {
		paths: {
			en: "/method",
			de: "/methode",
			fr: "/methode",
			it: "/metodo",
		},
	},
}
